import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=3946f5a6&scoped=true"
import script from "./Permissions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946f5a6",
  null
  
)

export default component.exports